<template>
  <div class="_footer">
    <div class="footer_conent">
      <p class="l_footer">
        <img src="@/assets/img/footer.png" alt="" />
      </p>
      <div class="r_footer">
        <!-- <p class="mail">
          <span>{{ $t('新闻中心咨询电话') }}：{{$t('+86 10 64529701')}}</span>
          <span>{{ $t('新闻中心咨询邮箱') }}：fmhxc-zx@ciftis.org.cn</span>
        </p> -->
        <p>{{ $t('北京市国际服务贸易事务中心版权所有') }}</p>
        <p>
          {{ $t('京ICP备 12034776号-1') }}
          <span class="footer_txt">
            <img src="@/assets/img/net.png" alt="" />
            <a
              target="_blank"
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502041813"
              >{{ $t('京公网安备11010502041813') }}</a
            >
          </span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {}
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {}
}
</script>
<style scoped lang="scss">
._footer {
  width: 100%;
  height: 180px;
  background-image: linear-gradient(-45deg, #7bc2df 0%, #0566d2 100%);
}
.footer_conent {
  width: 1200px;
  padding: 40px 0;
  margin: 0 auto;
}
.l_footer {
  width: 338px;
  float: left;
}
.r_footer {
  float: right;
  width: 710px;
  padding-left: 25px;
  border-left: 1px solid #62a6e0;
  font-size: 16px;
  color: #fff;
  & p {
    margin-top: 15px;
  }
  & p:last-child {
    margin-bottom: 15px;
  }
}
.mail span:nth-child(1)::after {
  content: '';
  display: inline-block;
  width: 1px;
  height: 20px;
  margin: -2px 15px;
  // padding-bottom: 30px;
  background: #eee;
}
.footer_txt {
  margin-left: 20px;
  color: #fff;
  a {
    color: #fff;
  }
  img {
    vertical-align: bottom;
  }
}
</style>
